import React from "react";
import SearchResult from "./SearchResult.js";

const SelectedResult = props => {
  const {
    selectedPinData,
    currentLocation,
    selectedResult,
    mapRef,
    setSelectedMarker
  } = props;

  return (
    <>
      {selectedPinData.map((location, index) => {
        return (
          <SearchResult
            key={index}
            result={location}
            currentLocation={currentLocation}
            selectedResult={selectedResult}
            mapRef={mapRef}
            setSelectedMarker={setSelectedMarker}
          />
        );
      })}
    </>
  );
};

export default SelectedResult;
